// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingTitle_root__2wowG"};